module.exports = __webpack_public_path__ + "static/img/ic_default_empty.ac8e810.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ic_default_empty.png
// module id = r5fZ
// module chunks = 0